(function () {
    'use strict';
    angular
        .module('cog.shared')
        .directive('categoryDetail', categoryDetail);
    /* @ngInject */
    function categoryDetail(appSettings) {
        var directive = {
            link: link,
            restrict: 'AE',
            templateUrl: appSettings.sharedPath + 'directives/category-detail-directive.tmpl.html',
            scope: {
                catid: '=catid',
                category: '=category',
                expand: '=expand',
                count: '=count'
            },
            controller: categoryDetailDirectiveController,
            controllerAs: 'vm',
        };
        return directive;
        function link($scope, $element) {
        }
    }
    /* @ngInject */
    function categoryDetailDirectiveController($scope, CogApiServiceProvider, PendingWagerTransformer, notificationService, $window) {
        var vm = this;
        vm.list = {};
        vm.list.Items = null;
        vm.list.isExpanded = false;
        vm.getNotExpanded = getNotExpanded;
        vm.count = $scope.count;
        vm.isLand = false;

        activate();

        function activate() {
            vm.isLand = getOrientation();
            if ($scope.expand) {
                vm.loader = true;
                CogApiServiceProvider.apiAccService().getTicketsCategory($scope.catid)
                .success(function (response: any) {
                    vm.list = PendingWagerTransformer.transformList(response);
                    vm.list.isExpanded = true;
                })
                .error(function (error) {
                })
                .finally(function () {
                    vm.loader = false;
                });
            }
        }

        function getNotExpanded() {
            if (vm.list.Items == null && vm.list.isExpanded) {
                vm.loader = true;
                CogApiServiceProvider.apiAccService().getTicketsCategory($scope.catid)
                .success(function (response: any) {
                    vm.list = PendingWagerTransformer.transformList(response);
                    vm.list.isExpanded = true;
                })
                .error(function (error) {
                })
                .finally(function () {
                    vm.loader = false;
                });
            }
        }

        notificationService.subscribe_toggleCategory($scope, function (event, args) {
            var show: boolean = args;
            if (show) {
                vm.list.isExpanded = true;
                if (vm.list.Items == null)
                    getNotExpanded();
            }
            else
                vm.list.isExpanded = false;
        });

        function getOrientation() {
            return $window.orientation == 0 || $window.orientation == 180 || $window.orientation == undefined ? false : true;
        }

        angular.element($window).bind('orientationchange', function () {
            vm.isLand = getOrientation();
        });
    }
})();
